import type { ReactElement } from "react";

import { useTranslations } from "next-intl";
import { H } from "../hero-tokens";
import { KundenstimmeItem } from "./kundenstimme-item";
import { kundenstimmen } from "./kundenstimmen-data";

/**
 * Marketing homepage band: customer video testimonials with quote beside each
 * clip. Data lives in kundenstimmen-data.ts — append there to add more.
 */
export function KundenstimmenSection(): ReactElement | null {
  const t = useTranslations("marketing.kundenstimmenSection");
  const tData = useTranslations("marketing.kundenstimmenData");
  const stimmen = kundenstimmen(tData);
  if (stimmen.length === 0) return null;

  return (
    <section
      aria-labelledby="kundenstimmen-heading"
      style={{
        maxWidth: 1240,
        margin: "72px auto clamp(56px, 7vw, 88px)",
        padding: "0 clamp(18px, 4vw, 28px)",
      }}
    >
      <div style={{ textAlign: "center", maxWidth: 640, margin: "0 auto" }}>
        <h2
          id="kundenstimmen-heading"
          style={{
            margin: 0,
            fontFamily: H.display,
            fontWeight: 400,
            fontSize: "clamp(2rem, 3.2vw, 2.75rem)",
            lineHeight: 1.08,
            letterSpacing: "-0.02em",
            color: H.ink,
          }}
        >
          {t("kundenstimmen")}
        </h2>
        <p
          style={{
            margin: "14px auto 0",
            fontSize: "clamp(0.98rem, 1.15vw, 1.08rem)",
            lineHeight: 1.55,
            color: H.inkMute,
          }}
        >
          {t("hausverwaltungenHausverwalterAiArbeiten")}
        </p>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "clamp(64px, 7vw, 96px)",
          marginTop: "clamp(36px, 4vw, 52px)",
        }}
      >
        {stimmen.map((item, index) => (
          <KundenstimmeItem key={item.id} item={item} index={index} />
        ))}
      </div>
    </section>
  );
}
